import { useAxios } from '../../Helpers/AxiosHelper';
import { useForm } from 'react-hook-form';
import { useToast } from '../../Helpers/ToastHelper';
import { useTranslation } from 'react-i18next';
import { Dialog, FloatLabel, InputText, SCButton, Controller, SubmitHandler, DDStatus, SelectButton, } from "../../Common/Imports"
import { ApiResponse, ConfigStatus_EXT } from '../../Models/Classes';


interface ConfigStatusNewProps {
    IDStakeholder: number;
    OnSave?: () => void;
}

const ConfigStatusNew: React.FC<ConfigStatusNewProps> = ({ IDStakeholder, OnSave }) => {
    const { t } = useTranslation();
    const { showToast } = useToast();
    const {
        handleSubmit,
        control
    } = useForm<ConfigStatus_EXT>();
    const AxiosHelper = useAxios();
    const Options = [
        { name: t("Common.Booleans.Yes"), value: true },
        { name: t("Common.Booleans.No"), value: false }
    ];

    const onSubmit: SubmitHandler<ConfigStatus_EXT> = async (data: ConfigStatus_EXT) => {
        data.idStakeholder = IDStakeholder;
        try {
            await AxiosHelper.post<ApiResponse<ConfigStatus_EXT>>(`StakeholderConfigs/Status/CreateConfig`, data);
            showToast('success', 'Success', t("Common.Toasts.Save.Success"));
            if (OnSave) {
                OnSave();
            }
        } catch (error: unknown) {
            console.log(error);
            showToast('error', 'Error', t("Common.Toasts.Save.Error"));
        }
    };

    const footerTemplate = () => (
        <div className="col d-flex justify-content-end">
            <SCButton Name="Save" Label={t("Common.Buttons.Save")} OnClick={handleSubmit(onSubmit)} />
        </div>
    );

    return (
        <Dialog
            header="Create Status Configuration"
            visible={true}
            onHide={() => {
                if (OnSave) {
                    OnSave();
                }
            }}
            footer={footerTemplate}
        >
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                <div className="row mb-3 mt-3" style={{ minWidth: "1000px" }}>
                    <Controller
                        name="customerStatus"
                        control={control}
                        rules={{ required: `${t("Stakeholder.Configs_Status.Edit.CustomerStatus")} ${t("Common.Form.Required")}` }}
                        render={({ field, fieldState }) => (
                            <div className="col-md-6 mb-4">
                                <FloatLabel>
                                    <InputText
                                        {...field}
                                        value={field.value}
                                        onBlur={field.onBlur}
                                    />
                                    <label htmlFor="subject">{t("Stakeholder.Configs_Status.Edit.CustomerStatus")}</label>
                                </FloatLabel>
                                {fieldState.invalid && (
                                    <small className="p-error">
                                        {fieldState.error?.message}
                                    </small>
                                )}
                            </div>
                        )}
                    />
                    <Controller
                        name="idStatus"
                        control={control}
                        rules={{ required: `${t("Stakeholder.Configs_Status.Edit.InternalStatus")} ${t("Common.Form.Required")}` }}
                        render={({ field, fieldState }) => (
                            <div className="col-md-6 mb-4">
                                <FloatLabel>
                                    <DDStatus
                                        {...field}
                                        IDType={1}
                                        value={field.value}
                                        onBlur={field.onBlur}
                                    />
                                    <label htmlFor="subject">{t("Stakeholder.Configs_Status.Edit.InternalStatus")}</label>
                                </FloatLabel>
                                {fieldState.invalid && (
                                    <small className="p-error">
                                        {fieldState.error?.message}
                                    </small>
                                )}
                            </div>
                        )}
                    />
                </div>
                <div className="row mb-3 mt-3" style={{ minWidth: "1000px" }}>
                    <Controller
                        name="allowMail"
                        control={control}
                        render={({ field, fieldState }) => (
                            <div className="col-md-6 mb-4">
                                <label htmlFor="subject" className="mb-3 mt-3">{t("Stakeholder.Configs_Status.Edit.AllowMail")}</label>
                                <SelectButton
                                    className={"SuccessError"}
                                    {...field}
                                    value={field.value}
                                    optionLabel="name"
                                    options={Options} />
                                {fieldState.invalid && (
                                    <small className="p-error">
                                        {fieldState.error?.message}
                                    </small>
                                )}
                            </div>
                        )}
                    />
                    <Controller
                        name="allowCall"
                        control={control}
                        render={({ field, fieldState }) => (
                            <div className="col-md-6 mb-4">
                                <label htmlFor="subject" className="mb-3 mt-3">{t("Stakeholder.Configs_Status.Edit.AllowCall")}</label>
                                <SelectButton
                                    className={"SuccessError"}
                                    {...field}
                                    value={field.value}
                                    optionLabel="name"
                                    options={Options} />
                                {fieldState.invalid && (
                                    <small className="p-error">
                                        {fieldState.error?.message}
                                    </small>
                                )}
                            </div>
                        )}
                    />
                </div>
            </form>
        </Dialog >
    );
};

export default ConfigStatusNew;
